import { FC } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { Grid, Skeleton } from '@mui/material';
import { seoSegmentationListingPage_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_activitySearchResults as activitiesSearchResults } from '@/__generated__/seoSegmentationListingPage';
import { seoActivitySegmentationListingPage_seoSegmentationActivityDetails_SEOSegmentationActivityDetailsSuccess_segmentDetails as SEOActivityDetails } from '@/__generated__/seoActivitySegmentationListingPage';
import { ActivityCardListItem } from './ActivitiesCardListItem';

interface ActivitiesListProps {
  activityDetails: SEOActivityDetails;
  searchResult: activitiesSearchResults[];
  isLoading: boolean;
}

const ActivityGrid: FC<{ children: React.ReactNode }> = ({ children }) => (
  <Grid container columnSpacing={3} mb={4} rowSpacing={4} sx={{ position: 'relative' }}>
    {children}
  </Grid>
);

export const ActivitiesList: FC<ActivitiesListProps> = ({
  activityDetails,
  searchResult,
  isLoading,
}) => {
  const skeleton = new Array(21).fill(null).map(() => ({ id: uuidv4() }));

  return (
    <ActivityGrid>
      {isLoading
        ? skeleton.map(({ id }) => (
            <Grid item key={`card-loader-${id}`} data-testid="card-loader">
              <Skeleton variant="rounded" width={315} height={353} />
            </Grid>
          ))
        : searchResult.map((activity) => (
            <Grid item xs={12} sm={6} md={4} key={uuidv4()}>
              <ActivityCardListItem
                activityDetails={activityDetails}
                activity={activity.seoSegmentationActivity}
              />
            </Grid>
          ))}
    </ActivityGrid>
  );
};
